import { useShowResponseStatus } from '@/shared';
import { useGetUsersQuery } from '../store/users-api';

export const useGetPartners = () => {
  const { data, isLoading, isError } = useGetUsersQuery(
    {
      isPartner: true,
      pageSize: 100,
    },
    {
      refetchOnMountOrArgChange: true,
    },
  );

  useShowResponseStatus({
    isError,
    errorMassage: 'При получении списка партнёров произошла ошибка',
  });

  return {
    partners: data?.items ?? [],
    isLoading,
  };
};
